@if (values?.length) {
  <div class="items-container mb-2">
    @for (value of values; track $index) {
      <crm-transit-task-car-category-limits-entry-form
        [value]="value"
        (onDeleteClick)="onDeleteValue($index)"></crm-transit-task-car-category-limits-entry-form>
    }
  </div>
} @else {
  <div class="w-full flex justify-content-center align-items-center">
    <span class="font-light">Нет лимитов</span>
  </div>
}

<div class="w-full flex justify-content-end align-items-center">
  <crm-button
    icon="pi pi-plus"
    label="Добавить"
    styleClass="p-button-text"
    (onClick)="onAddValue()"></crm-button>
</div>
